<template>
  <div class="content-wrapper">
    <!-- <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button :to="`/forms/add`" color="primary" type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row> -->

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(publish_status)="data">
          <span v-if="data.item.publish_status == 1" class="text-success"
            >Active</span
          >
          <span v-if="data.item.publish_status == 0" class="text-danger"
            >Inactive</span
          >
        </template>

        <template v-slot:cell(pro_name)="data">
          <strong>{{ data.item.pro_name }}</strong>
          <div class="text-grey mt-2">
            <i class="fas fa-map-marker-alt"></i>
            {{ data.item.venue }}
          </div>
        </template>

        <template v-slot:cell(form_type)="data">
          <div>{{
            data.item.form_type
          }}</div>
        </template>

        <template v-slot:cell(date)="data">
          <strong>{{ data.item.date }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <a :href="`/pages/${data.item.page_id}`" >
            <vs-button color="primary" type="flat"
              >View</vs-button
            >
          </a>
        </template>
      </b-table>
    </vx-card>
  </div>
</template>

<script>
import Service from "@/services";
import { mapState } from "vuex";

export default {
  data: () => ({
    columns: [
      { label: "ID", key: "page_id", sortable: false },
      { label: "Status", key: "publish_status", sortable: false },
      {
        label: "Title",
        key: "title",
        sortable: false,
        tdClass: "width-450",
      },
      // {
      //   label: "Type",
      //   key: "type",
      // },
      // { label: "Date Start", key: "datetime_start", sortable: false },
      // { label: "Date End", key: "datetime_end", sortable: false },
      { label: "", key: "action", sortable: false },
    ],
    formTypes: [
      {
        label: "Attendee Info",
        value: "attendee-info",
      },
      {
        label: "Pre-event Interest",
        value: "pre-event-interest",
      },
      {
        label: "Post-event Survey",
        value: "post-event-survey",
      },
      {
        label: "Vote",
        value: "vote",
      },
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
  }),
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
  mounted() {
    window.addEventListener("keydown", (e) => {
      if (this.remarkDialog == false) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },

  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      //console.log("loading...");
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.e,
          s: this.s,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        console.log(params);

        Service.Content.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;
            this.log = res.log;

            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1800);
    },
    open(item) {
      //console.log(item);
      this.$router.push("/forms/" + item.form_id);
    },
  },
};
</script>

<style>
.width-250 {
  width: 250px;
}
.width-300 {
  width: 300px;
}
.width-450 {
  width: 450px;
}
</style>
